import { useState } from "react"
import { Link } from "react-router-dom"

/* form */
import Input from "../../../shared/components/form/input"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"


function FormColorType({ handleSubmit, colorTypeData, btnText, btCancelLink, btCancelAction, title }) {

    const [colorType, setColorType] = useState(colorTypeData || {})

    function handleChange(e) {
        setColorType({ ...colorType, [e.target.name]: e.target.value })
    }

    function submit(e) {
        e.preventDefault()
        // Evita que o submit borbulhe (via árvore React, mesmo com o Modal via portal) e
        // acione também o onSubmit do formulário que abriu este como "cadastro rápido".
        e.stopPropagation()
        handleSubmit(colorType)
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection>
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Nome do Tipo de Cor"
                            type="text"
                            name="name"
                            placeholder="digite o nome do tipo de cor"
                            handleOnChange={handleChange}
                            value={colorType.name || ''}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormColorType
